import shouldShowBrandDecoration from './shouldShowBrandDecoration';
import { isGroupTableQuery } from 'owa-group-common';
import { getItemClassIcon } from 'owa-mail-list-actions';
import doesConversationHaveDrafts from 'owa-mail-list-actions/lib/utils/doesConversationHaveDrafts';
import getCleanPreview from 'owa-mail-list-actions/lib/utils/getCleanPreview';
import { mailStore } from 'owa-mail-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import strings from 'owa-strings/owa-mail-strings';
import { trace } from 'owa-trace';
import { getTableConversationRelation, isItemOfMessageType, listViewStore, MailRowDataPropertyGetter, } from 'owa-mail-list-store';
import { searchStore as searchStoreV1 } from 'owa-mail-search-store';
import { mailSearchStore as searchStoreV2 } from 'owa-mail-search';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import isConversationExpanded from 'owa-mail-list-store/lib/selectors/isConversationExpanded';
export default function getMailListItemDataProps(rowKey, mailListTableProps) {
    var tableView = listViewStore.tableViews.get(mailListTableProps.tableViewId);
    var listViewType = tableView.tableQuery.listViewType;
    // VSO 20477: Combine getMailListItemPropsForConversation and getMailListItemPropsForItem
    switch (listViewType) {
        case 0 /* Conversation */:
            return getMailListItemPropsForConversation(rowKey, tableView, mailListTableProps);
        case 1 /* Message */:
            return getMailListItemPropsForItem(rowKey, tableView, mailListTableProps);
        default:
            trace.warn('Not supported listViewType:' + listViewType);
            return null;
    }
}
function getMailListItemPropsForItem(rowKey, tableView, mailListTableProps) {
    if (!rowKey) {
        throw new Error('getMailListItemPropsForItem: ItemId should be present for given rowKey');
    }
    var rowId = MailRowDataPropertyGetter.getRowIdString(rowKey, tableView);
    var item = mailStore.items.get(rowId);
    if (!item) {
        trace.error('getMailListItemDataProps: item does not exist in cache.');
        return null;
    }
    if (!item.ParentFolderId) {
        trace.error('getMailListItemDataProps: item.ParentFolderId is null.');
    }
    if (!item.ConversationId) {
        trace.error('getMailListItemDataProps: item.ConversationId is null.');
        return null;
    }
    if (!item.ItemId) {
        trace.error('getMailListItemDataProps: item.ItemId is null.');
        return null;
    }
    var message;
    if (isItemOfMessageType(item)) {
        message = item;
    }
    else {
        message = null;
    }
    var searchStore = isMailFeatureEnabled('sea-commonSearchBox') ? searchStoreV2 : searchStoreV1;
    var userConfiguration = getUserConfiguration();
    // Calculate first two line displays
    var isItemPinned = MailRowDataPropertyGetter.getIsPinned(rowKey, tableView);
    var subject = item.Subject ? item.Subject : strings.noSubject;
    var draftsId = folderNameToId('drafts');
    var sentItemsId = folderNameToId('sentitems');
    var junkFolderId = folderNameToId('junkemail');
    var isDraftsFolder = tableView.tableQuery.folderId == draftsId;
    var parentFolderId = item.ParentFolderId && item.ParentFolderId.Id;
    var isItemInDraftsFolder = isDraftsFolder || parentFolderId == draftsId;
    var isItemInSentItemsFolder = tableView.tableQuery.folderId == sentItemsId || parentFolderId == sentItemsId;
    var isItemInJunkFolder = tableView.tableQuery.folderId == junkFolderId || parentFolderId == junkFolderId;
    var isSearchNotInDraftOrSentItemFolder = tableView.tableQuery.type == 1 /* Search */ &&
        searchStore.staticSearchScope &&
        searchStore.staticSearchScope.folderId != sentItemsId &&
        searchStore.staticSearchScope.folderId != draftsId;
    var senderName = message && message.From && message.From.Mailbox ? message.From.Mailbox.Name : '';
    var _a = getSendersOrRecipients([item.DisplayTo], [senderName], MailRowDataPropertyGetter.getLastSenderSMTP(rowKey, tableView), isItemInSentItemsFolder, isItemInDraftsFolder, isSearchNotInDraftOrSentItemFolder), sendersOrRecipients = _a.sendersOrRecipients, singleLastSenderSMTP = _a.singleLastSenderSMTP;
    var firstLineText;
    var firstLineTooltipText;
    var secondLineText;
    var secondLineTooltipText;
    // Show pinned items rows in condensed view when
    // table supports it and
    // item is pinned
    var showCondensedView = mailListTableProps.showCondensedPinnedRows && isItemPinned;
    // When in condensed view we only show subject of the row and render only first line.
    // Therefore we assign subject to first (top) line regardless of the user setting.
    var shouldShowSenderOnTop = userConfiguration.UserOptions.ShowSenderOnTopInListView && !showCondensedView;
    if (mailListTableProps.isSingleLine ||
        shouldShowSenderOnTop ||
        isDraftsFolder // When in Drafts folder we always show recipients on the first line irrespective of user's settings
    ) {
        firstLineText = sendersOrRecipients;
        firstLineTooltipText = singleLastSenderSMTP;
        secondLineText = subject;
        secondLineTooltipText = null;
    }
    else {
        secondLineText = sendersOrRecipients;
        secondLineTooltipText = singleLastSenderSMTP;
        firstLineText = subject;
        firstLineTooltipText = null;
    }
    // Do not populate third line text if preview is disabled
    var thirdLineText = userConfiguration.UserOptions.ShowPreviewTextInListView
        ? getCleanPreview(item.Preview)
        : null;
    // We make the assumption that if a ReceivedOrRenewTime != DateTimeReceived the item must either be pinned or snoozed.
    // If the item has a return time or is NOT pinned and has the above inequality, we will mark the item as snoozed.
    var isSnoozed = mailListTableProps.supportsSnooze &&
        (!!item.ReturnTime ||
            (!isItemPinned &&
                item.ReceivedOrRenewTime &&
                !isTimestampEqual(item.ReceivedOrRenewTime, item.DateTimeReceived)));
    var itemClassIcon = getItemClassIcon([item.ItemClass], item.IconIndex, false /* hasIrm */);
    var unreadCount = 0;
    if (message) {
        unreadCount = message.IsRead ? 0 : 1;
    }
    var showAttachmentPreviews = userConfiguration.UserOptions.ShowInlinePreviews &&
        isMailFeatureEnabled('tri-messageAttachmentPreviews') &&
        item.shouldShowAttachmentPreviews;
    return {
        canDelete: !isGroupTableQuery(tableView.tableQuery),
        categories: item.Categories,
        conversationId: item.ConversationId && item.ConversationId.Id,
        effectiveMentioned: item.MentionedMe,
        firstLineText: firstLineText,
        firstLineTooltipText: firstLineTooltipText,
        hasAttachment: item.HasAttachments,
        importance: item.Importance,
        isExpanded: false,
        isFlagged: item.Flag ? item.Flag.FlagStatus == 'Flagged' : false,
        isPinned: isItemPinned,
        isSelected: tableView.selectedRowKeys.has(rowKey),
        itemClassIcon: itemClassIcon,
        itemCount: 1,
        lastDeliveryTimestamp: item.DateTimeReceived,
        lastSender: message && message.From,
        latestItemId: item.ItemId && item.ItemId.Id,
        likeCount: message && message.LikeCount ? message.LikeCount : null,
        parentFolderId: parentFolderId,
        rowId: rowId,
        rowKey: rowKey,
        secondLineText: secondLineText,
        secondLineTooltipText: secondLineTooltipText,
        showAttachmentPreview: showAttachmentPreviews,
        showBrandDecoration: !isItemInJunkFolder && shouldShowBrandDecoration(singleLastSenderSMTP),
        isUnauthenticatedSender: message && message.AntispamUnauthenticatedSender,
        isSnoozed: isSnoozed,
        returnTime: getItemReturnTime(item, isSnoozed),
        showCondensedView: showCondensedView,
        showDraftsIndicator: item.IsDraft,
        subject: subject,
        thirdLineText: thirdLineText,
        unreadCount: unreadCount,
        validCouponIndexes: item.validCouponIndexes,
    };
}
function getMailListItemPropsForConversation(rowKey, tableView, mailListTableProps) {
    var searchStore = isMailFeatureEnabled('sea-commonSearchBox') ? searchStoreV2 : searchStoreV1;
    var tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);
    var rowId = tableConversationRelation.id;
    var conversationItem = listViewStore.conversationItems.get(rowId);
    var userConfiguration = getUserConfiguration();
    if (!conversationItem) {
        // Converting exception to trace error here to prevent app crash.
        // VSO 25058: Investigate why conversationItem not found in store in getMailListItemDataProps
        trace.error({
            message: 'Conversation not found in store',
            diagnosticInfo: 'rowId is ' + rowId,
        });
        return null;
    }
    // Get item status (pin / flag)
    var isPinned = MailRowDataPropertyGetter.getIsPinned(rowKey, tableView);
    var isFlagged = tableConversationRelation.flagStatus == 'Flagged';
    var effectiveMentioned = tableConversationRelation.effectiveMentioned;
    // Calculate first two line displays
    var subject = conversationItem.subject ? conversationItem.subject : strings.noSubject;
    var draftsId = folderNameToId('drafts');
    var sentItemsId = folderNameToId('sentitems');
    var junkFolderId = folderNameToId('junkemail');
    var isDraftsFolder = tableView.tableQuery.folderId == draftsId;
    var parentFolderId = tableConversationRelation.parentFolderId;
    var isItemInDraftsFolder = isDraftsFolder || parentFolderId == draftsId;
    var isItemInSentItemsFolder = tableView.tableQuery.folderId == sentItemsId || parentFolderId == sentItemsId;
    var isItemInJunkFolder = tableView.tableQuery.folderId == junkFolderId || parentFolderId == junkFolderId;
    var isSearchNotInDraftOrSentItemFolder = tableView.tableQuery.type == 1 /* Search */ &&
        searchStore.staticSearchScope &&
        searchStore.staticSearchScope.folderId != sentItemsId &&
        searchStore.staticSearchScope.folderId != draftsId;
    var _a = getSendersOrRecipients(tableConversationRelation.uniqueRecipients, tableConversationRelation.uniqueSenders, MailRowDataPropertyGetter.getLastSenderSMTP(rowKey, tableView), isItemInSentItemsFolder, isItemInDraftsFolder, isSearchNotInDraftOrSentItemFolder), sendersOrRecipients = _a.sendersOrRecipients, singleLastSenderSMTP = _a.singleLastSenderSMTP;
    // Show conversation row in condensed view when
    // table supports condensed view
    // they are pinned and
    // not expanded
    var showCondensedView = mailListTableProps.showCondensedPinnedRows && isPinned && !isConversationExpanded(rowKey);
    // When in condensed view we only show subject of the row and render only first line.
    // Therefore we assign subject to first (top) line regardless of the user setting.
    var shouldShowSenderOnTop = userConfiguration.UserOptions.ShowSenderOnTopInListView && !showCondensedView;
    var firstLineText;
    var firstLineTooltipText;
    var secondLineText;
    var secondLineTooltipText;
    if (mailListTableProps.isSingleLine ||
        shouldShowSenderOnTop ||
        isDraftsFolder // When in Drafts folder we always show recipients on the first line irrespective of user's settings
    ) {
        firstLineText = sendersOrRecipients;
        firstLineTooltipText = singleLastSenderSMTP;
        secondLineText = subject;
        secondLineTooltipText = null;
    }
    else {
        secondLineText = sendersOrRecipients;
        secondLineTooltipText = singleLastSenderSMTP;
        firstLineText = subject;
        firstLineTooltipText = null;
    }
    // Do not populate third line text if preview is disabled
    var thirdLineText = userConfiguration.UserOptions.ShowPreviewTextInListView
        ? getCleanPreview(tableConversationRelation.previewText)
        : null;
    // Add [Drafts] indicator if the conversation has any drafts
    var showDraftsIndicator = doesConversationHaveDrafts(tableConversationRelation);
    var showAttachmentPreviews = userConfiguration.UserOptions.ShowInlinePreviews &&
        conversationItem.shouldShowAttachmentPreviews;
    // We make the assumption that if a lastDeliveryOrRenewTimeStamp != lastDeliveryTimeStamp the conversation must either be pinned or snoozed.
    // If the conversation has a return time or is NOT pinned and has the above inequality, we will mark the conversation as snoozed.
    var isSnoozed = isMailFeatureEnabled('tri-snooze') &&
        mailListTableProps.supportsSnooze &&
        (!!tableConversationRelation.returnTime ||
            (!isPinned &&
                !isTimestampEqual(tableConversationRelation.lastDeliveryOrRenewTimeStamp, tableConversationRelation.lastDeliveryTimeStamp)));
    var itemClassIcon = getItemClassIcon(tableConversationRelation.itemClasses, tableConversationRelation.iconIndex, tableConversationRelation.hasIrm);
    return {
        rowKey: rowKey,
        rowId: rowId,
        conversationId: rowId,
        firstLineText: firstLineText,
        firstLineTooltipText: firstLineTooltipText,
        secondLineText: secondLineText,
        secondLineTooltipText: secondLineTooltipText,
        thirdLineText: thirdLineText,
        isExpanded: isConversationExpanded(rowKey),
        isFlagged: isFlagged,
        isPinned: isPinned,
        isSelected: tableView.selectedRowKeys.has(rowKey),
        canDelete: !isGroupTableQuery(tableView.tableQuery),
        unreadCount: tableConversationRelation.unreadCount,
        itemCount: conversationItem.globalItemIds.length,
        subject: subject,
        categories: tableConversationRelation.categories,
        lastSender: tableConversationRelation.lastSender,
        latestItemId: tableConversationRelation.itemIds[0],
        lastDeliveryTimestamp: tableConversationRelation.lastDeliveryTimeStamp,
        itemClassIcon: itemClassIcon,
        importance: tableConversationRelation.importance,
        hasAttachment: tableConversationRelation.hasAttachments,
        showDraftsIndicator: showDraftsIndicator,
        showAttachmentPreview: showAttachmentPreviews,
        validCouponIndexes: conversationItem.validCouponIndexes,
        effectiveMentioned: effectiveMentioned,
        parentFolderId: parentFolderId,
        likeCount: tableConversationRelation.globalLikeCount,
        showBrandDecoration: !isItemInJunkFolder && shouldShowBrandDecoration(singleLastSenderSMTP),
        isUnauthenticatedSender: false,
        isSnoozed: isSnoozed,
        returnTime: getTableConversationRelationReturnTime(tableConversationRelation, isSnoozed),
        showCondensedView: showCondensedView,
    };
}
function getSendersOrRecipients(recipients, uniqueSenders, lastSenderSMTP, isItemInSentItemsFolder, isItemInDraftsFolder, isSearchNotInDraftOrSentItemFolder) {
    var sendersOrRecipients;
    var singleLastSenderSMTP;
    if ((isItemInSentItemsFolder || isItemInDraftsFolder) && !isSearchNotInDraftOrSentItemFolder) {
        // Show recipients for conversations belonging to drafts and sentitems folders
        // EXCEPT when we are in a search scenario since we want the preview text, name, and circle persona to match
        sendersOrRecipients = recipients && recipients.join('; ');
        singleLastSenderSMTP = null;
    }
    else {
        sendersOrRecipients = uniqueSenders && uniqueSenders.join('; ');
        // Show tooltip text when there is single sender
        singleLastSenderSMTP = uniqueSenders && uniqueSenders.length === 1 ? lastSenderSMTP : null;
    }
    // If there are no senders or no recipients add a default string [Unknown]
    // For an item in a drafts folder user may not have defined any recipients
    // For items (in both sent & drafts) that do not have recipients in To: and
    // have recipients in Cc:/Bcc: we do not receive any recipients today from server.
    if (!sendersOrRecipients) {
        sendersOrRecipients = isItemInDraftsFolder ? '' : strings.unknownSenderOrRecipient;
    }
    return { sendersOrRecipients: sendersOrRecipients, singleLastSenderSMTP: singleLastSenderSMTP };
}
// Helper function to normalize and compare date times for isSnoozed calculation. This function is
// required to normalize times returned by search results with millisecond. For the present we will
// simply ignore milliseconds and assume the two times are equal when in search.
function isTimestampEqual(time1, time2) {
    return new Date(time1).setMilliseconds(0) == new Date(time2).setMilliseconds(0);
}
// Return item's return time IF the item has a defined return time. Otherwise, if we know
// item is snoozed and the return time does not exist (ex: in inbox), we will rely on RoRT.
function getItemReturnTime(item, isSnoozed) {
    return item.ReturnTime ? item.ReturnTime : isSnoozed ? item.ReceivedOrRenewTime : null;
}
// Return TCR's return time IF the TCR has a defined return time. Otherwise, if we know
// the TCR was snoozed and the return time does not exist (ex: in inbox), we will rely on LDoRT.
function getTableConversationRelationReturnTime(tableConversationRelation, isSnoozed) {
    return tableConversationRelation.returnTime
        ? tableConversationRelation.returnTime
        : isSnoozed
            ? tableConversationRelation.lastDeliveryOrRenewTimeStamp
            : null;
}
//# sourceMappingURL=getMailListItemDataProps.js.map